// Single source of truth for contact details. Updating here flows everywhere.

// UK intake WhatsApp anchor — currently the same Zim number (priority-assessment line).
// Update WHATSAPP_NUMBER_RAW if/when the UK intake number changes.
export const UK_INTAKE_WHATSAPP_NUMBER_RAW = "263786543884";
export const UK_INTAKE_WHATSAPP_DISPLAY = "+263 78 654 3884";

// Existing public-contact (Zim) WhatsApp shown in the footer.
export const PUBLIC_WHATSAPP_NUMBER_RAW = "263786543884";
export const PUBLIC_WHATSAPP_DISPLAY = "+263 78 654 3884";

export const CONTACT_EMAIL = "admin@heartreachcounselling.com";

// UK office landline (auto-formatted to E.164 for the tel: link)
export const UK_OFFICE_PHONE_RAW = "+441158711577";
export const UK_OFFICE_PHONE_DISPLAY = "0115 871 1577";

const PRIORITY_MESSAGE =
  "Hi Heart Reach, I'd like to book a priority assessment for my relative in Zimbabwe.";

export function whatsappUrl(rawNumber, message) {
  const base = `https://wa.me/${rawNumber}`;
  if (!message) return base;
  return `${base}?text=${encodeURIComponent(message)}`;
}

export const UK_INTAKE_WHATSAPP_URL = whatsappUrl(
  UK_INTAKE_WHATSAPP_NUMBER_RAW,
  PRIORITY_MESSAGE
);

export const PUBLIC_WHATSAPP_URL = whatsappUrl(PUBLIC_WHATSAPP_NUMBER_RAW);
